module.exports = __webpack_public_path__ + "static/media/upload_hcm.1ca1d85c.svg";